import { Inject, Pipe, PipeTransform } from '@angular/core';
import { BASE_URL } from 'src/core-lib/misselaineous/boot.tokens';

@Pipe({
    name: 'isExternal'
})
export class IsExternalPipe implements PipeTransform {
    readonly isApp = /\:\/\//g;

    constructor(@Inject(BASE_URL) private baseUrl: string) {}

    transform(value: string, isDownloadable: boolean): boolean {
        if (value == null)
            return false;
        return isDownloadable ||
            value.startsWith('tel:') ||
            value.startsWith('mailto:') ||
            this.isApp.test(value) ||
            (value.startsWith('http') && !value.startsWith(this.baseUrl));
    }

}
